import { Splitter } from "./utils/index.js";

export default class Slideinfo {
	constructor(el) {
		this.DOM = { el: el };

		this.DOM.text = {
			index: this.DOM.el.querySelectorAll(".slide__index .char"),
			subtitle: this.DOM.el.querySelector(".slide__text--subtitle"),
			title: this.DOM.el.querySelectorAll(".slide__text--title .char"),
			description: this.DOM.el.querySelector(".slide__text--description"),
			more: this.DOM.el.querySelector(".slide__text--more"),
		};

		const split = new Splitter(this.DOM.text.description);

		const lines = [...split.linesEl.children].map((c) => [...c.children][0]);
		this.DOM.text.descriptionLines = lines;
		this.DOM.text.more = lines;
	}
}
